// src/redux/actions/salesActions.js
import { 
    FETCH_SE_ANALYTIC_REQUEST, 
    FETCH_SE_ANALYTIC_SUCCESS, 
    FETCH_SE_ANALYTIC_FAILURE 
} from '../../../../../Constants/actionTypes';
import { fetchSEAnalytics } from '../../../../../Constants/apiService'

// Fetch Sales Request Action
export const fetchSEAnalyticsRequest = () => ({
    type: FETCH_SE_ANALYTIC_REQUEST,
});

// Fetch Sales Success Action
export const fetchSEAnalyticsSuccess = (salesData) => ({
    type: FETCH_SE_ANALYTIC_SUCCESS,
    payload: salesData,
});

// Fetch Sales Failure Action
export const fetchSEAnalyticsFailure = (error) => ({
    type: FETCH_SE_ANALYTIC_FAILURE,
    payload: error,
});

// Thunk Action Creator for Fetching Sales
export const fetchSEAnalyticsFuc = () => {
    return async (dispatch, getState) => {
        dispatch(fetchSEAnalyticsRequest());

        const state = getState();
        const accessToken = state.auth.accessToken; 


        try {
            const data = await fetchSEAnalytics(accessToken);
            console.log(data)
            dispatch(fetchSEAnalyticsSuccess(data));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(fetchSEAnalyticsFailure(errorMessage));
        }
    };
};
